// extracted by mini-css-extract-plugin
export default {"content":"wRDpK","image":"DlVm3","description":"qHa4v","buttons-container":"WN2lm","buttonsContainer":"WN2lm"};